"use client";

import { useEffect } from "react";

import { EventKeyValues } from "@/lib/observability/catalog";
import { EventPublisher } from "@/lib/observability/events";

interface PageViewTrackerProps {
  eventKey: EventKeyValues;
  data?: Record<string, any>;
}

export function PageViewTracker({ data = {}, eventKey }: PageViewTrackerProps) {
  useEffect(() => {
    void EventPublisher.publishEvent(eventKey, data);
  }, [eventKey, data]);

  return null;
}
